/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_Notetaker_Issue_Removed_TitleInputs */



/**
* | output |
* | --- |
* | "The notetaker was removed from the meeting" |
*
* @param {Meeting_Notetaker_Issue_Removed_TitleInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meeting_notetaker_issue_removed_title = /** @type {((inputs?: Meeting_Notetaker_Issue_Removed_TitleInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Notetaker_Issue_Removed_TitleInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("De notetaker werd uit de meeting gezet")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Le notetaker a été retiré de la réunion")
	return /** @type {LocalizedString} */ ("The notetaker was removed from the meeting")
});